import { StyleSheet } from 'react-native'
import { fontFamily } from '../../../../../theme'

export const styles = StyleSheet.create({
  informationGame: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 40
  },
  information: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  informationTitle: {
    color: 'white',
    textAlign: 'center',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontWeight: 'bold',
    fontSize: 14,
    lineHeight: 19.2
  },
  informationText: {
    color: 'white',
    textAlign: 'center',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontWeight: '400',
    fontSize: 20,
    lineHeight: 21.6
  },
  informationIconText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5
  },
  informationWithOutIcon: {
    marginTop: 2
  }
})
